var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXlsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "34px",
    height: "34px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.8,12.8) scale(0.9,0.9)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "rgba(244,246,245,0)",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-14.22222,270.22222v-284.44444h284.44444v284.44444z",
    id: "bgRectangle"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#297b49",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.88889,270.22222c-39.27358,0 -71.11111,-31.83753 -71.11111,-71.11111v-142.22222c0,-39.27358 31.83753,-71.11111 71.11111,-71.11111h142.22222c39.27358,0 71.11111,31.83753 71.11111,71.11111v142.22222c0,39.27358 -31.83753,71.11111 -71.11111,71.11111z",
    id: "shape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41,10h-16v28h16c0.553,0 1,-0.447 1,-1v-26c0,-0.553 -0.447,-1 -1,-1z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,15h7v3h-7zM32,25h7v3h-7zM32,30h7v3h-7zM32,20h7v3h-7zM25,15h5v3h-5zM25,25h5v3h-5zM25,30h5v3h-5zM25,20h5v3h-5z",
    fill: "#297b49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,42l-21,-4v-28l21,-4z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.129,31l-2.411,-4.561c-0.092,-0.171 -0.186,-0.483 -0.284,-0.938h-0.037c-0.046,0.215 -0.154,0.541 -0.324,0.979l-2.421,4.52h-3.757l4.462,-7.001l-4.083,-6.999h3.837l2.001,4.196c0.156,0.331 0.296,0.725 0.42,1.179h0.04c0.078,-0.271 0.224,-0.68 0.439,-1.22l2.226,-4.155h3.515l-4.199,6.939l4.316,7.059h-3.74z",
    fill: "#297b49"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsIcon);
export default __webpack_public_path__ + "static/media/xls-icon.ca7fad97bfdb4e82b5fcd8c5e0d8e4ed.svg";
export { ForwardRef as ReactComponent };